module.exports = __webpack_public_path__ + "media/images/icons/calendar-gray-icon-f5d9663cdd54359a03ff598d6d468003.svg";